import { jsx as t } from "react/jsx-runtime";
import e from "@mui/material/Backdrop";
import { makeStyles as s } from "tss-react/mui";
import a from "./BackdropSpinner.style.js";
import c from "../ThreeDots/ThreeDots.js";
const p = s()(a), d = ({ show: o = !1 }) => {
  const { classes: r } = p();
  return /* @__PURE__ */ t(e, { "data-testid": o ? "showBackdrop" : "hideBackdrop", className: r.backdrop, open: o, children: /* @__PURE__ */ t(c, { color: "#FFFFFF", height: 16, width: 60 }) });
}, h = d;
export {
  h as default
};
